<template>
  <section v-editable="cms" :class="[name, spacing]">
    <grid
      :class="[{ 'grid--container': !fullwidth }, `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="`${name}__grid-item`"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 24 },
        ]"
      >
        <div :class="`${name}__items`">
          <div
            v-for="(item, index) in cms.stats"
            :key="index"
            :class="`${name}__item`"
          >
            <a-heading
              v-if="item.heading"
              :cms="item"
              :class="`${name}__heading`"
            />
            <!-- eslint-disable vue/no-v-html -->
            <div
              v-if="item.copy"
              :class="`${name}__text`"
              v-html="$options.filters.markdown(item.copy)"
            />
            <!--eslint-enable-->
          </div>
        </div>
      </grid-item>
    </grid>
  </section>
</template>

<script>
import Colors from '~/mixins/colors'
import data from '~/components/molecules/m-articles/m-article-stats.data'

export default {
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'm-article-stats',
    }
  },

  computed: {
    spacing() {
      return this.cms.spacing
    },
    fullwidth() {
      return this.cms.fullwidth || false
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-article-stats {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: transparent;

  &__items {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-auto-flow: dense;
    justify-items: center;
    text-align: center;
  }
  &__item {
    padding: 30px 0;
  }
  &__heading {
    @include font-size(36, 40.8px);

    margin: 0 0 20px;
  }
}

@include media-breakpoint-up(md) {
  .m-article-stats {
    min-height: 163px;
    &__items {
      grid-template-columns: repeat(3, 1fr);
      text-align: initial;
    }
  }
}

@include media-breakpoint-up(lg) {
  .m-article-stats {
    &__heading {
      @include font-size(58, 72px);
    }
  }
}
</style>
